let SUPERSET_USERNAME = 'admin';
let SUPERSET_SECRET = '12dfErf4^sd*dS3]F4Gs*dT_oP43z';

export const environment = {
  appVersion: require('../../package.json').version + '-uat',
  production: false,

  BASE_URL : 'https://buckzypaymentsinc-dev.apigee.net/sbox_rebuild_api/api',
  
  SUPERSET_URL: 'http://34.70.176.100:8088/login?username='+SUPERSET_USERNAME+'&secret='+SUPERSET_SECRET+'&redirect_url=',

  RE_CAPTCHA_SITE_KEY: '6Le3wvUUAAAAAOGI2zEPMmnv4jOi6fXZIZ9UgL-T',

  AUTH : {
      API_KEY: 'YwaTauxpAeTMPlAk8AaNhxEgRflxx9FM',
      AUTH_BASE: 'https://nginx-new.sb.buckzy.cloud/AuthService',
      AUTH_URL : '/oauth/token',
      MFA_SETUP_URL: '/auth/mfa/setup',

      APP_ID : 'DEMO_OSLO_CLIENT',
      APP_PWD: 'eW$HWJ5$243ZwUax',

      TYPE : 'BD',

  },

  PAY_LATER : {
    ENABLED: false,
  },
  ACH : {
    ENABLED: true,
    MAX: 100000,
  },

  PLAID : {
    ENABLED: false,
    BASE_URL : 'https://plaid-sb.buckzy.net/PlaidService',
    OPTIONS : {
      clientName: 'Plaid Quickstart',
      language: 'en',
      env: 'sandbox',
      selectAccount: true,
      key: 'd675c8e77a29deb226beba95a7c92d',
      product: ['transactions'],
      // Optional – use webhooks to get transaction and error updates
      webhook: 'https://requestb.in',
    },
  },

};
